import DrawModeBase from '@/lib/mapbox/draw-mode-base'
import {
  getEndpointsMarkerGeoJson,
  getRouteGeoJson,
} from '@/lib/mapbox/route-mode-helpers'

/**
 * Renders the current route held by the route builder service.
 */
class RouteViewMode extends DrawModeBase {
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line require-await
  async toDisplayFeatures(routeGeoJson) {
    const route = getRouteGeoJson()
    if (route) {
      routeGeoJson.geometry = route
    } else {
      routeGeoJson.geometry = null
    }

    const markers = getEndpointsMarkerGeoJson()

    return [routeGeoJson, ...markers]
  }
}

export default RouteViewMode
